<p>consumption profile list-view works!</p>